import { Container, Typography, Button, Box, Grid } from "@mui/material";
import AppleIcon from "@mui/icons-material/Apple";
import AdbIcon from "@mui/icons-material/Adb";
import { useAuth } from "../../providers/AuthenticationProvider";
import XseeLogo from "../../assets/logo.png"; // Import your Xsee logo image
import { useTranslation } from "react-i18next";
import ShopIcon from "@mui/icons-material/Shop";
import { useTranslationProvider } from "../../providers/TranslationProvider";
export const FirstTimePurchaseComplete = () => {
	const { temporaryPassword } = useAuth();
	const { language } = useTranslationProvider();
	const { t } = useTranslation();
	function redirect(url: string) {
		window.location.href = url;
	}

	return (
		<Container maxWidth="md" sx={{ textAlign: "center", mt: {xs:16, md:18} }}>
			<Typography
				variant="h4"
				sx={{ fontFamily: "Work Sans", fontWeight: 600, mb: 2, mt: 2 }}
			>
				Your password has been set temporarily
			</Typography>
			<Typography variant="body1" sx={{ fontFamily: "Work Sans", mb: 4 }}>
				An email has been sent to you with instructions to change it.
			</Typography>
			<Typography
				variant="subtitle1"
				sx={{ fontFamily: "Work Sans", mb: 4 }}
			>
				Temporary Password: <strong>{temporaryPassword}</strong>
			</Typography>

			<Box
				sx={{
					padding: window.innerWidth > 600 ? "8vh 0" : "2vh 1vh",
				}}
			>
				<Container>
					<Grid container spacing={0}>
						<Grid
							md={6}
							xs={12}
							sx={{
								padding: "20px",
							}}
						>
							<Box className="card">
								<Box
									sx={{
										background: "#131721",
										width: "72px",
										height: "72px",
										textAlign: "center",
										borderRadius: "100px",
									}}
								>
									<AppleIcon
										sx={{
											fontSize: "32px",
											marginTop: "20px",
											color: "#fff",
										}}
									></AppleIcon>
								</Box>

								<div className="titleCard">
									<span className="badge">
										{t("landing.mobilePhone")}
									</span>
									iOS
								</div>
								<div className="textCard">
									{language == "it" && (
										<>
											Installa l'app di xsee sul tuo
											dispositivo{" "}
											<b>Apple</b>
										</>
									)}
									{language == null ||
										(language == "en" && (
											<>
												Install the xsee app on your{" "}
												<b>Apple</b> device
											</>
										))}
								</div>

								<Button
									variant="contained"
									color="secondary"
									startIcon={<AppleIcon />}
									sx={{
										textTransform: "none",
										margin: "16px 0 8px 0",
										fontWeight: "600",
										borderRadius: "100px",
									}}
									onClick={() => {
										redirect(
											"https://apps.apple.com/it/app/xsee/id6467227843"
										);
									}}
								>
									Download iOS
								</Button>
							</Box>
						</Grid>

						<Grid
							md={6}
							xs={12}
							sx={{
								padding: "20px",
							}}
						>
							<Box className="card">
								<Box
									sx={{
										background: "#131721",
										width: "72px",
										height: "72px",
										textAlign: "center",
										borderRadius: "100px",
									}}
								>
									<AdbIcon
										sx={{
											fontSize: "32px",
											marginTop: "20px",
											color: "#fff",
										}}
									></AdbIcon>
								</Box>
								<div className="titleCard">
									<span className="badge">
										{t("landing.mobilePhone")}
									</span>
									Android
								</div>
								<div className="textCard">
									{language == "it" && (
										<>
											Installa l'app di xsee sul tuo
											dispositivo{" "}
											<b>Android</b>
										</>
									)}
									{language == null ||
										(language == "en" && (
											<>
												Install the xsee app on your{" "}
												<b>Android</b> device
											</>
										))}
								</div>

								<Button
									variant="contained"
									color="secondary"
									startIcon={<ShopIcon />}
									sx={{
										textTransform: "none",
										margin: "16px 0 8px 0",
										fontWeight: "600",
										borderRadius: "100px",
									}}
									onClick={() => {
										redirect(
											"https://play.google.com/store/apps/details?id=com.sinapsa.Xsee&pli=1"
										);
									}}
								>
									Download Android
								</Button>
							</Box>
						</Grid>
					</Grid>
				</Container>
			</Box>
		</Container>
	);
};
